import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import client from "@/lib/api";

export default function PaymentResult({ cancelled = false }) {
  const params = new URLSearchParams(useLocation().search);
  const sessionId = params.get("session_id");
  const [state, setState] = useState(cancelled ? "cancelled" : "polling");

  useEffect(() => {
    if (cancelled || !sessionId) return;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await client.get(`/public/payment/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState("failed"); return; }
      } catch { /* keep trying */ }
      tries += 1;
      if (tries >= 10) { setState("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId, cancelled]);

  const Card = ({ icon, title, text, tone }) => (
    <div className="min-h-screen flex items-center justify-center px-6 bg-slate-50">
      <div className="max-w-md w-full text-center bg-white rounded-2xl border border-slate-200 p-10" data-testid="payment-result">
        <div className={`h-14 w-14 rounded-full mx-auto flex items-center justify-center mb-4 ${tone}`}>{icon}</div>
        <h1 className="font-display text-2xl font-bold">{title}</h1>
        <p className="text-slate-500 mt-2">{text}</p>
        <Link to="/" className="inline-block mt-6 px-6 py-2.5 rounded-xl bg-slate-900 text-white text-sm font-semibold">Retour</Link>
      </div>
    </div>
  );

  if (state === "polling") return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50" data-testid="payment-polling">
      <Loader2 className="h-10 w-10 animate-spin text-indigo-500" />
      <p className="text-slate-500 mt-4">Confirmation du paiement…</p>
    </div>
  );
  if (state === "paid") return <Card tone="bg-emerald-100 text-emerald-600" icon={<CheckCircle2 className="h-7 w-7" />} title="Inscription confirmée !" text="Votre paiement a bien été reçu. Un email récapitulatif vous sera envoyé." />;
  if (state === "cancelled") return <Card tone="bg-amber-100 text-amber-600" icon={<XCircle className="h-7 w-7" />} title="Paiement annulé" text="Aucun montant n'a été débité. Vous pouvez reprendre votre inscription quand vous le souhaitez." />;
  if (state === "timeout") return <Card tone="bg-slate-100 text-slate-500" icon={<Loader2 className="h-7 w-7" />} title="Paiement en cours de traitement" text="La confirmation prend un peu plus de temps que prévu. Vous recevrez un email dès validation." />;
  return <Card tone="bg-rose-100 text-rose-600" icon={<XCircle className="h-7 w-7" />} title="Paiement non abouti" text="Le paiement n'a pas pu être finalisé. Merci de réessayer." />;
}
